export default {
  subtotal: 'Subtotaal',
  tip: 'Fooi',
  discount: 'Korting',
  method_fee: 'Bezorgkosten',
  service_fee: {
    title: 'Servicekosten',
    description:
      'Deze kleine servicekosten helpen ons de kosten te dekken die bij elke bestelling komen — zoals het sturen van sms-updates over je bestelling, het beheren van ons online bestelplatform en het verwerken van transactiekosten. En maak je geen zorgen — deze kosten zijn nog steeds veel lager dan wat je bij bezorgapps zou betalen. Bedankt voor je begrip en voor de directe steun. We stellen het zeer op prijs!',
  },
  payment_method_upcharge_fee: {
    title: 'PayPal-kosten',
    description:
      'Elke keer dat een klant betaalt met PayPal, rekent PayPal 6-7% kosten. Op 100€ verliezen we dus 6-7€. Daarom moeten we helaas een toeslag van 3,5% toevoegen voor gebruik van PayPal. 🤯 Overweeg een van de andere veilige en versleutelde betaalmethoden te gebruiken bij het afrekenen. We zijn erg dankbaar voor je begrip en steun! 🙏',
  },
  tax: 'Belastingen',
  total: 'Totaal',
  earned_points: 'Je hebt {{points}} punten verdiend',
};
